import { Component, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { KanbanAppComponent } from '../kanban.app.component';
import { Subscription } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { KanbanService } from '../service/kanban.service';
import {Assignee, Comment, KanbanCard} from "../api/kanban";
import {InplaceModule} from "primeng/inplace";
import {FormsModule} from "@angular/forms";
import {SidebarModule} from "primeng/sidebar";
import {OverlayPanelModule} from "primeng/overlaypanel";
import {CalendarModule} from "primeng/calendar";
import {ProgressBarModule} from "primeng/progressbar";
import {CheckboxModule} from "primeng/checkbox";
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {AutoCompleteModule} from "primeng/autocomplete";
import {AvatarModule} from "primeng/avatar";
import {InputTextModule} from "primeng/inputtext";
import {Ripple} from "primeng/ripple";
import {TooltipModule} from "primeng/tooltip";
import {InputTextareaModule} from "primeng/inputtextarea";

@Component({
    selector: 'app-kanban-sidebar',
    templateUrl: './kanban-sidebar.component.html',
    standalone: true,
    imports: [
        InplaceModule,
        FormsModule,
        SidebarModule,
        OverlayPanelModule,
        CalendarModule,
        ProgressBarModule,
        CheckboxModule,
        NgClass,
        AutoCompleteModule,
        AvatarModule,
        NgIf,
        InputTextModule,
        Ripple,
        TooltipModule,
        NgForOf,
        InputTextareaModule
    ],
    providers: [
      KanbanService
    ],
    styleUrls: ['./kanban-sidebar.component.scss']
})
export class KanbanSidebarComponent implements OnDestroy {

    card: KanbanCard = {id:'', no: '', title: '', status: 'open', state: '', description: '', recipient: '', targetDate: ''};

    formValue!: KanbanCard;

    listId: string = '';

    filteredAssignees: any[] = [];

    assignees: any[] = [];

    newComment: Comment = { id: '123', name: 'Jane Cooper', text: '' };

    newTask: any = { text: '', completed: false };

    comment: string = '';

    taskContent: string = '';

    timeout: any = null;

    showTaskContainer: boolean = false;

    menuItems: MenuItem[] = [];

    listNames: {listId: string, title: string}[] = [{listId: '', title: 'list title'}];

    cardSubscription: Subscription;

    listSubscription: Subscription;

    listNameSubscription: Subscription;

    @ViewChild('inputTitle') inputTitle!: ElementRef;

    @ViewChild('inputTaskListTitle') inputTaskListTitle!: ElementRef;

    constructor(public parent: KanbanAppComponent, private kanbanService: KanbanService) {

        this.cardSubscription = this.kanbanService.selectedCard$.subscribe(data => {
            this.card = data;
            this.formValue = {...data};

        });
        this.listSubscription = this.kanbanService.selectedListId$.subscribe(data => this.listId = data);
        this.listNameSubscription = this.kanbanService.listNames$.subscribe(data => this.listNames = data);
    }

    ngOnDestroy() {
        this.cardSubscription.unsubscribe();
        this.listSubscription.unsubscribe();
        this.listNameSubscription.unsubscribe();
        clearTimeout(this.timeout);
    }

    close() {
        this.parent.sidebarVisible = false;
        // this.resetForm();
    }

    filterAssignees(event: any) {
        let filtered: any[] = [];
        let query = event.query;

        for (let i = 0; i < this.assignees.length; i++) {
            let assignee = this.assignees[i];
            if (assignee.name && assignee.name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
                filtered.push(assignee);
            }
        }

        this.filteredAssignees = filtered;
    }

    // onComment(event: Event) {
    //     event.preventDefault();
    //     if (this.comment.trim().length > 0) {
    //         this.newComment = { ...this.newComment, text: this.comment }
    //         this.formValue?.comments?.unshift(this.newComment);
    //         this.comment = '';
    //     }
    // }

    onSave(event: any) {
        event.preventDefault();
        this.card = {...this.formValue};
        this.kanbanService.updateCard(this.card, this.listId);
        this.close();
    }

    onMove(listId: string) {
        this.kanbanService.moveCard(this.formValue, listId, this.listId);
    }

    onDelete() {
        this.kanbanService.deleteCard(this.formValue?.id || '', this.listId);
        this.parent.sidebarVisible = false;
        // this.resetForm();
    }

    // resetForm() {
    //     this.formValue =  {id:'' ,taskList: {title: 'Untitled Task List', tasks: []}};
    // }

    // addTaskList() {
    //     this.showTaskContainer = !this.showTaskContainer;
    //
    //     if (!this.showTaskContainer) {
    //         return;
    //     }
    //     else if (!this.formValue.taskList) {
    //         let id = this.kanbanService.generateId();
    //         this.formValue = { ...this.formValue, taskList: { title: 'Untitled Task List', tasks: []  } };
    //     }
    // }

    // addTask(event: Event) {
    //     event.preventDefault();
    //     if (this.taskContent.trim().length > 0) {
    //         this.newTask = { text: this.taskContent, completed: false };
    //         this.formValue.taskList?.tasks.unshift(this.newTask);
    //         this.taskContent = '';
    //         this.calculateProgress();
    //     }
    // }

    focus(arg: number) {
        if (arg == 1) {
            this.timeout = setTimeout(() => this.inputTitle.nativeElement.focus(), 1);
        }
        if (arg == 2) {
            this.timeout = setTimeout(() => this.inputTaskListTitle.nativeElement.focus(), 1);
        }
    }

    // calculateProgress() {
    //     if(this.formValue.taskList) {
    //         let completed = this.formValue.taskList.tasks.filter((t: any) => t.completed).length;
    //         this.formValue.progress = Math.round(100 * (completed / this.formValue.taskList.tasks.length));
    //     }
    // }

}
